/* eslint-disable indent */
import { destroyPaymentMethod, updateUser } from '../services'

export const destroyPaymentCard = async (
  id,
  paymentMethods,
  me,
  setUser,
  _selectedPaymentMethodId,
) => {
  try {
    await destroyPaymentMethod(id)
    paymentMethods = paymentMethods.filter(p => p.id !== id)
    let storage = JSON.parse(sessionStorage.getItem('book'))

    const selectedPaymentMethodId = !paymentMethods.length
      ? null
      : me.defaultPaymentMethodId === id
        ? paymentMethods[0].id
        : _selectedPaymentMethodId

    if (storage) {
      storage = {
        ...storage,
        paymentMethods,
        selectedPaymentMethodId
      }
      sessionStorage.setItem('book', JSON.stringify(storage))
    }

    if (!paymentMethods.length || _selectedPaymentMethodId === id) {
      await updateUser({
        id: me.id,
        defaultPaymentMethodId: selectedPaymentMethodId
      })
    }

    setUser({
      ...me,
      paymentMethods,
      defaultPaymentMethodId: selectedPaymentMethodId
    })
    return paymentMethods.length
  } catch (e) {
    console.error(e)
  }
}
